import { setUtilsCustomConfig } from '@vas2t-lowcode/utils';

export interface CustomConfig4ApiType {
  /**
   * 工具包配置
   */
  utils: Parameters<typeof setUtilsCustomConfig>[0];
  /**
   * api url基础路径
   */
  baseURL?: string;
  /**
   * 同时，此参数也作为ajax超时时间设置，单位毫秒
   * @default 5000
   */
  ajaxTimeout?: number;
  /**
   * 登陆
   */
  toLoginPageAsync?: () => Promise<void>;
  /**
   * 登出
   */
  cb4Logout?: () => void;
  // isWhiteUrl() {
  //   return false;
  // },
}

const CONFIG_4_API_DEFAULT = {
  utils: {
    timeMin4Sentry: 3e3,
    timeMax4Sentry: 5e3,
  },
};

let config4Api: CustomConfig4ApiType = {
  utils: { ...CONFIG_4_API_DEFAULT.utils },
};

export function setApiCustomConfig(options: CustomConfig4ApiType) {
  // 保存api配置信息
  config4Api = { ...CONFIG_4_API_DEFAULT, ...options };
  // 配置utils
  const { utils } = config4Api;
  setUtilsCustomConfig({
    timeMin4Sentry: utils.timeMin4Sentry,
    timeMax4Sentry: utils.timeMax4Sentry,
    elMessage: utils.elMessage,
  });
}

export function getApiCustomConfig() {
  return config4Api;
}
